//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBM_BASIC_03 from './M_TBM_BASIC_03';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_BASIC_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보
  const [inputs, setInputs] = useState({
    isNext: false,
  });
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState([]);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1); // 100% 화면 너비로 시작
  const [pageViewHeight, setPageViewHeight] = useState(0); // 페이지 렌더링 높이 상태 추가
  //#endregion

  // 스택형 뒤로가기로 변경: 확인 모달이 열린 동안 뒤로가기를 막음
  useBackStack({
    type: 'block',
    enabled: props.modalToggle2 === true,
    onBack: () => {},
  });

  useEffect(() => {
    Init();
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1); // 화면 크기 바뀔 때 다시 계산
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber]);

  const Init = async () => {
    setLoading(true);

    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //#region 조회

  // 교육자료 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setInputs({
      ...inputs,
      video: '',
      isNext: true,
    });

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R2',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          if (!data[0].EDU_LOCATION) {
            setInputs({
              ...inputs,
              isNext: true,
            });
          } else {
            setInputs({
              ...inputs,
            });
            const path = data[0].EDU_LOCATION;
            const full = Global.file.useUrl + 'files/' + path;

            setPdfFile(path);
            setFullUrl(full);

            // PDF 이미지 미리보기 생성
            if (getExtensionFromUrl(path) === 'pdf') {
              generatePdfPreview(full);
            }
            // if (getExtensionFromUrl(path) === 'pptx') {
            //   generatePptPreview(full);
            // }
            if (
              getExtensionFromUrl(path) === 'hwp' ||
              getExtensionFromUrl(path) === 'hwpx'
            ) {
              generateHwpPreview(full);
            }
          }
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const generateHwpPreview = async (url) => {
    // 원본 PDF 파일을 fetch
    const response = await fetch(url.replace(/\.hwp$/i, '.pdf'));
    const blob = await response.blob();

    // PDF 전체를 가리키는 blob URL 생성
    const blobUrl = URL.createObjectURL(blob);

    // 상태에 저장해서 뷰어에 사용
    setRenderPreview(blobUrl);
  };

  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const generatePdfPreview = async (url) => {
    // 원본 PDF 파일을 fetch
    const response = await fetch(url);
    const blob = await response.blob();

    // PDF 전체를 가리키는 blob URL 생성
    const blobUrl = URL.createObjectURL(blob);

    // 상태에 저장해서 뷰어에 사용
    setRenderPreview(blobUrl);
  };
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };
  //#endregion

  return (
    <M_TBM_BASIC_03
      userInfo={userInfo}
      pdfFile={pdfFile}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      check={props.check}
      setCheck={props.setCheck}
      userCount={props.userCount}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
      getExtensionFromUrl={getExtensionFromUrl}
      // 함수
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      ActiveButton={props.ActiveButton}
    />
  );
}

export default M_TBM_BASIC_03F;
